import { useState } from 'react';
import { Grid, Typography } from '@mui/material';
import { WhiteContainer } from 'src/style/common';
import { CardTitleContainer } from 'src/pages/Settings/components/BillingInfo/index';
import { CompanyForm } from 'src/pages/Company/components/CompanyForm';
import { useGetCurrentUserQuery } from 'src/redux/services/users';
import { useGetCompanyAdminQuery } from 'src/redux/services/companiesAdmin';
import CompanyInfoSkeleton from './CompanyInfoSkeleton';
import SnackBarCustom from 'src/frontend-common/components/SnackbarCustom';

const CompanyInfo = () => {
  const [showSnackBar, setShowSnackBar] = useState<boolean>(false);
  const [updateSuccess, setUpdateSuccess] = useState<boolean>(false);
  const { data: currentUserData, isError: currentUserIsError } = useGetCurrentUserQuery();

  const companyId = currentUserData?.item && currentUserData.item.company ? currentUserData.item.company.id : '';

  const { data: companyData, isFetching: companyIsFetching, isError: companyError } = useGetCompanyAdminQuery(companyId, { skip: companyId === '' });

  const isError = currentUserIsError || companyError ? true : false;

  if (isError) {
    setUpdateSuccess(false);
    setShowSnackBar(true);
  }

  const handleFeedBack = (update: boolean) => {
    setUpdateSuccess(update);
    setShowSnackBar(true);
  };

  return (
    <>
      <WhiteContainer container={true}>
        <Grid item={true} xs={12}>
          <CardTitleContainer>
            <Typography variant="h5" data-testid="companyTitle">
              Company
            </Typography>
            <>
              {companyIsFetching && !companyData && <CompanyInfoSkeleton />}
              {!isError && companyData && <CompanyForm companyData={companyData} reducedVersion={true} sendFeedBack={handleFeedBack} />}
            </>
          </CardTitleContainer>
        </Grid>
      </WhiteContainer>
      <SnackBarCustom
        open={showSnackBar}
        message={!updateSuccess ? 'An error occured while fetching data' : 'Company updated successfully'}
        severity={updateSuccess ? 'success' : 'error'}
        onClose={() => setShowSnackBar(false)}
      />
    </>
  );
};

export default CompanyInfo;
